export const network = {
  title: 'SynthoNetwork',
  subtitle: 'Soluzioni di Rete Affidabili',
  hero: {
    title: 'Rete ad Alte Prestazioni',
    subtitle: 'Copertura IT & DE',
    description: 'Soluzioni IP Transit Sicure'
  },
  whyUs: {
    title: 'Perché Sceglierci?',
    description: 'Puntiamo molto a migliorare i nostri servizi, non saremo i migliori ma stiamo cercando di diventarlo. Il nostro impegno costante nel miglioramento e l\'attenzione alle esigenze dei clienti ci distingue nel settore.'
  },
  contact: {
    title: 'Come Contattarci',
    description: 'Contattaci via email o telefono. Il nostro team è pronto ad assisterti per qualsiasi richiesta.',
    company: {
      name: 'MULTI SERVICE S.R.L.S.',
      address: 'Via Isonzo 102 - 73055 Racale (LE)',
      vat: 'P.IVA / VAT.ID IT 05316380756',
      rea: 'REA: LE - 358063'
    }
  },
  lookingGlass: {
    title: 'Looking Glass',
    description: 'Verifica la connettività e le informazioni di routing',
    tools: [
      {
        name: 'Test Ping',
        description: 'Testa la connettività verso un host'
      },
      {
        name: 'Traceroute',
        description: 'Visualizza il percorso di rete verso la destinazione'
      },
      {
        name: 'Route BGP',
        description: 'Controlla le informazioni di routing BGP'
      }
    ]
  },
  services: {
    title: 'I Nostri Servizi',
    description: 'Soluzioni complete di rete e hosting',
    items: [
      {
        title: 'Game Hosting',
        description: 'Hosting server di gioco a bassa latenza con protezione DDoS'
      },
      {
        title: 'VPS Hosting',
        description: 'Server virtuali ad alte prestazioni con risorse dedicate'
      },
      {
        title: 'Server Dedicati',
        description: 'Hardware dedicato potente per applicazioni esigenti'
      }
    ]
  },
  pricing: {
    title: 'Prezzi di Rete',
    description: 'Tariffe competitive per servizi di rete premium',
    contact: 'Contattaci per preventivi personalizzati'
  },
  prefixes: {
    title: 'Prefissi di Rete',
    description: 'Visualizza i nostri prefissi di rete e le informazioni ASN',
    table: {
      location: 'Posizione',
      subnet: 'Subnet',
      type: 'Tipo di Rete',
      description: 'Descrizione'
    },
    networks: [
      {
        location: 'Germania',
        subnet: '194.36.26.0/24',
        type: 'IPv4',
        description: 'SynthoHosting - Sede DE'
      },
      {
        location: 'Germania',
        subnet: '2a0d:b287:ec00::/40',
        type: 'IPv6',
        description: 'SynthoHosting - Sede DE'
      }
    ]
  }
};